"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var content_1 = require("../model/content");
var chain_1 = require("../api/chain");
var transactionBuilder_1 = require("../transactionBuilder");
var util_1 = require("util");
var database_1 = require("../api/model/database");
var transaction_1 = require("../model/transaction");
var ApiModule_1 = require("./ApiModule");
var utils_1 = require("../utils");
var chain_2 = require("../api/model/chain");
var types_1 = require("../model/types");
var validator_1 = require("./validator");
var moment = require('moment');
var ContentError;
(function (ContentError) {
    ContentError["database_operation_failed"] = "operation_failed";
    ContentError["fetch_content_failed"] = "fetch_content_failed";
    ContentError["transaction_broadcast_failed"] = "transaction_broadcast_failed";
    ContentError["restore_content_keys_failed"] = "restore_content_keys_failed";
    ContentError["asset_fetch_failed"] = "asset_fetch_failed";
    ContentError["asset_not_found"] = "asset_not_found";
    ContentError["content_not_exist"] = "content_not_exist";
    ContentError["account_fetch_failed"] = "account_fetch_failed";
    ContentError["parameters_error"] = "parameters_error";
    ContentError["api_connection_failed"] = "api_connection_failed";
    ContentError["syntactic_error"] = "syntactic_error";
    ContentError["content_not_bought"] = "content_not_bought";
    ContentError["invalid_arguments"] = "invalid_arguments";
})(ContentError = exports.ContentError || (exports.ContentError = {}));
/**
 * ContentApi provide methods to communication
 * with content stored in DCore network.
 */
var ContentModule = /** @class */ (function (_super) {
    __extends(ContentModule, _super);
    function ContentModule(dbApi, chainApi, apiConnector) {
        return _super.call(this, {
            dbApi: dbApi,
            chainApi: chainApi,
            apiConnector: apiConnector
        }) || this;
    }
    /**
     * Searches content submitted to DCore network and is not expired.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a4526e41a8bf7bc921072d11cec0c894c
     *
     * @param {SearchParams} searchParams       Parameters for content filtering.
     * @param {boolean} convertAsset            Optional parameter to convert amounts and fees of Content from blockchain asset
     *                                          amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                          Default: false.
     * @return {Promise<Content[]>}             List of Content object that conform search parameters.
     */
    ContentModule.prototype.searchContent = function (searchParams, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (searchParams && !validator_1.Validator.validateObject(searchParams, database_1.SearchParams)
            || !validator_1.Validator.validateArguments([convertAsset], [types_1.Type.boolean])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        var dbOperation = new database_1.DatabaseOperations.SearchContent(searchParams);
        return new Promise(function (resolve, reject) {
            _this.dbApi
                .execute(dbOperation)
                .then(function (content) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    resolve(content.map(function (c) {
                        c.synopsis = JSON.parse(c.synopsis);
                        if (c.price && convertAsset) {
                            c = _this.formatPrices(c, assets);
                        }
                        return c;
                    }));
                })
                    .catch(function (err) {
                    reject(_this.handleError(ContentError.database_operation_failed, err));
                });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.database_operation_failed, err));
            });
        });
    };
    /**
     * Get content object from blockchain for given content id
     *
     * @param {string} id                   Id of content to get. Example: '2.13.345'
     * @param {boolean} convertAsset        Optional parameter to convert amounts and fees of Content from blockchain asset
     *                                      amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                      Default: false.
     * @return {Promise<Content | null>}    Content object.
     */
    ContentModule.prototype.getContent = function (id, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([id, convertAsset], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) {
            var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
            _this.dbApi.execute(listAssetsOp)
                .then(function (assets) {
                var dbOperation = new database_1.DatabaseOperations.GetObjects([id]);
                _this.dbApi
                    .execute(dbOperation)
                    .then(function (contents) {
                    if (!contents || !contents[0]) {
                        resolve(null);
                        return;
                    }
                    var content = contents[0];
                    var stringified = JSON.stringify(content);
                    var objectified = JSON.parse(stringified);
                    objectified.synopsis = JSON.parse(objectified.synopsis);
                    if (util_1.isUndefined(objectified.price['amount']) && convertAsset) {
                        objectified = _this.formatPrices([objectified], assets)[0];
                    }
                    resolve(objectified);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.fetch_content_failed, err)); });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.database_operation_failed, err));
            });
        });
    };
    /**
     * Get content with given URI.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a1790db302a96536fe8be9794969fbfdb
     *
     * @param {string} URI                  Content URI
     * @param {boolean} convertAsset        Optional parameter to convert amounts and fees of Content from blockchain asset
     *                                      amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                      Default: false.
     * @returns {Promise<Content | null>}   Content object.
     */
    ContentModule.prototype.getContentURI = function (URI, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([URI, convertAsset], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) {
            var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
            _this.dbApi.execute(listAssetsOp)
                .then(function (assets) {
                var dbOperation = new database_1.DatabaseOperations.GetContent(URI);
                _this.dbApi
                    .execute(dbOperation)
                    .then(function (content) {
                    if (!content) {
                        resolve(null);
                        return;
                    }
                    var stringified = JSON.stringify(content);
                    var objectified = JSON.parse(stringified);
                    objectified.synopsis = JSON.parse(objectified.synopsis);
                    if (util_1.isUndefined(objectified.price['amount']) && convertAsset) {
                        objectified = _this.formatPrices([objectified], assets);
                    }
                    resolve(objectified);
                });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.database_operation_failed, err));
            });
        });
    };
    /**
     * Cancel submitted content in blockchain.
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#a51951fe58f271369898d529e537bf45e
     *
     * @param {string} contentId        Content id in format '2.13.X'. Example: '2.13.1234'
     * @param {string} authorId         Author id in format'1.2.X'. Example: '1.2.345'
     * @param {string} privateKey       Author's private key to submit transaction in WIF(hex) (Wallet Import Format) format.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @return {Promise<void>}          Value confirming successful transaction broadcasting.
     */
    ContentModule.prototype.removeContent = function (contentId, authorId, privateKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([contentId, authorId, privateKey, broadcast], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) {
            _this.getContent(contentId)
                .then(function (content) {
                var URI = content.URI;
                var cancelOperation = new transaction_1.Operations.ContentCancelOperation(authorId, URI);
                var transaction = new transactionBuilder_1.TransactionBuilder();
                transaction.addOperation(cancelOperation);
                _this.finalizeAndBroadcast(transaction, privateKey, broadcast)
                    .then(function (res) { return resolve(transaction.operations[0]); })
                    .catch(function (err) { return reject(err); });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.fetch_content_failed, err));
            });
        });
    };
    /**
     * Restores key to decrypt downloaded content.
     *
     * ElGamalPrivate contains keys used to identify if user have bought content.
     * May contains older keys, if elGamal keys pair were changed,
     * to restore content bought before keys have been changed. Otherwise content keys
     * would not be restored.
     * https://docs.decent.ch/developer/group___database_a_p_i___decent.html#gaa952f1c2adc2781d42a3f457e2d18d09
     *
     * @param {string} contentId                Content id in format '2.13.X', Example: '2.13.453'
     * @param {string} accountId                Account if in format '1.2.X'. Example: '1.2.345'
     * @param {...string[]} elGamalKeys         El Gamal keys to identify that user bought content. May contains older keys, if el gamal
     *                                          keys pair were changed, to restore content bought before keys have been changed.
     *                                          Otherwise content keys would not be restored.
     * @returns {Promise<string>}               Content key to decrypt content.
     */
    ContentModule.prototype.restoreContentKeys = function (contentId, accountId) {
        var _this = this;
        var elGamalKeys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            elGamalKeys[_i - 2] = arguments[_i];
        }
        if (!validator_1.Validator.validateArguments(arguments, [types_1.Type.string, types_1.Type.string, [Array, types_1.Type.string]])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) {
            _this.getContent(contentId)
                .then(function (content) {
                var dbOperation = new database_1.DatabaseOperations.GetBuyingHistoryObjects(accountId, content.URI);
                _this.dbApi.execute(dbOperation)
                    .then(function (res) {
                    var validKey = elGamalKeys.find(function (elgPair) { return elgPair.publicKey === res.pubKey.s; });
                    if (!validKey) {
                        reject(_this.handleError(ContentError.restore_content_keys_failed, 'wrong keys'));
                    }
                    var dbOperation = new database_1.DatabaseOperations.RestoreEncryptionKey(contentId, validKey.privateKey);
                    _this.dbApi
                        .execute(dbOperation)
                        .then(function (key) {
                        resolve(key);
                    })
                        .catch(function (err) {
                        reject(_this.handleError(ContentError.restore_content_keys_failed, err));
                    });
                });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.fetch_content_failed, err)); });
        });
    };
    /**
     * Generate content key with key parts of each seeder to encrypt
     * content to be uploaded.
     * https://docs.decent.ch/developer/group___database_a_p_i___decent.html#ga4efd6c44e7257d496b79b102cd3d9358
     *
     * @param {string[]} seeders        Array of seeder account ids in format '1.2.X'. Example: ['1.2.12', '1.4.13']
     * @return {Promise<ContentKeys>}   Generated ContentKeys for content encryption.
     */
    ContentModule.prototype.generateContentKeys = function (seeders) {
        var _this = this;
        if (!validator_1.Validator.validateArguments(arguments, [[Array, types_1.Type.string]])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        var dbOperation = new database_1.DatabaseOperations.GenerateContentKeys(seeders);
        return new Promise(function (resolve, reject) {
            _this.dbApi
                .execute(dbOperation)
                .then(function (keys) {
                resolve(keys);
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.database_operation_failed, err));
            });
        });
    };
    /**
     * Submit content to blockchain
     * https://docs.decent.ch/developer/group___wallet_a_p_i___content.html#gae0af8d611b5d915264a892ad83254370
     *
     * @throws {TypeError}              Error is thrown in case of invalid input parameters.
     * @param {SubmitObject} content    SubmitObject with information about submitted object.
     * @param {string} privateKey       Private for sign transaction in WIF(hex) (Wallet Import Format) format.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @return {Promise<boolean>}       Value confirming successful transaction broadcasting.
     */
    ContentModule.prototype.addContent = function (content, privateKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([content, privateKey, broadcast], [content_1.SubmitObject, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            content.size = _this.getFileSize(content.size);
            var listAssetOp = new database_1.DatabaseOperations.GetAssets([
                content.assetId || chain_1.ChainApi.asset_id,
                content.publishingFeeAsset || chain_1.ChainApi.asset_id
            ]);
            var methods = [new chain_2.ChainMethods.GetAccount(content.authorId)];
            methods.push.apply(methods, content.coAuthors.map(function (ca) { return new chain_2.ChainMethods.GetAccount(ca[0]); }));
            (_a = _this.chainApi).fetch.apply(_a, methods).then(function (accounts) {
                var authorAccount = JSON.parse(JSON.stringify(accounts[0]));
                var coAuthors = JSON.parse(JSON.stringify(accounts))
                    .slice(1)
                    .map(function (coAuthor, index) {
                    return [coAuthor.id, content.coAuthors[index][1]];
                });
                _this.dbApi.execute(listAssetOp)
                    .then(function (assets) {
                    if (!assets || !assets[0] || !assets[1]) {
                        reject(_this.handleError(ContentError.fetch_content_failed));
                        return;
                    }
                    var priceAsset = assets[0];
                    var feeAsset = assets[1];
                    try {
                        var submitOperation = new transaction_1.Operations.SubmitContentOperation(content.size, authorAccount.id, coAuthors, content.URI, content.seeders.length, [{
                                region: 1,
                                price: {
                                    amount: utils_1.Utils.formatAmountToAsset(content.price, priceAsset),
                                    asset_id: priceAsset.id
                                }
                            }], content.hash, content.seeders.map(function (s) { return s.seeder; }), content.keyParts, content.date.toString(), {
                            amount: _this.calculateFee(content),
                            asset_id: feeAsset.id
                        }, JSON.stringify(content.synopsis));
                        var transaction_2 = new transactionBuilder_1.TransactionBuilder();
                        transaction_2.addOperation(submitOperation);
                        _this.finalizeAndBroadcast(transaction_2, privateKey, broadcast)
                            .then(function (res) { return resolve(transaction_2.operations[0]); })
                            .catch(function (err) { return reject(err); });
                    }
                    catch (e) {
                        reject(_this.handleError(ContentError.account_fetch_failed, e));
                        return;
                    }
                })
                    .catch(function (err) { return _this.handleError(ContentError.database_operation_failed, err); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.account_fetch_failed, err)); });
            var _a;
        });
    };
    /**
     * Get list of opened, not yet confirmed buy requests by seeders.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#ad4e75371b94ea3fd47cf4bd329b622aa
     *
     * @param {boolean} convertAsset            Optional parameter to convert amounts and fees of BuyingContent from blockchain asset
     *                                          amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                          Default: false.
     * @returns {Promise<BuyingContent[]>}      BuyingContent list of opened buy requests.
     */
    ContentModule.prototype.getOpenBuying = function (convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([convertAsset], [types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise((function (resolve, reject) {
            var operation = new database_1.DatabaseOperations.GetOpenBuyings();
            _this.dbApi.execute(operation)
                .then(function (buyingObjects) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    if (!assets || assets.length === 0) {
                        reject(_this.handleError(ContentError.asset_fetch_failed));
                        return;
                    }
                    var result = convertAsset ? _this.formatPrices(buyingObjects, assets) : buyingObjects;
                    resolve(result);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        }));
    };
    /**
     * Get list of opened, not yet confirmed buy requests by seeders.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a030ccb8c903503a700ecbbc87bf552af
     *
     * @param {string} URI                  Buy request URI. Example 'ipfs:QmQ9MBkzt6QcDtBhg7qenDcXtm1s6VVSogtSHa2zbXKsFb'
     * @param {boolean} convertAsset        Optional parameter to convert amounts and fees of BuyingContent from blockchain asset
     *                                      amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                      Default: false.
     * @returns {Promise<BuyingContent[]>}  BuyingContent list of opened buy requests.
     */
    ContentModule.prototype.getOpenBuyingByURI = function (URI, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([URI, convertAsset], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise((function (resolve, reject) {
            var operation = new database_1.DatabaseOperations.GetOpenBuyingsByURI(URI);
            _this.dbApi.execute(operation)
                .then(function (buyingObjects) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    if (!assets || assets.length === 0) {
                        reject(_this.handleError(ContentError.asset_fetch_failed));
                        return;
                    }
                    var result = convertAsset ? _this.formatPrices(buyingObjects, assets) : buyingObjects;
                    resolve(result);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        }));
    };
    /**
     * Get list of opened, not yet confirmed buy requests by seeders.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a767fc3bb252b35c33618f12083aa3064
     *
     * @param {string} accountId            Account id in format '1.2.X'. Example '1.2.345'
     * @param {boolean} convertAsset        Optional parameter to convert amounts and fees of BuyingContent from blockchain asset
     *                                      amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                      Default: false.
     * @returns {Promise<BuyingContent[]>}  BuyingContent list of opened buy requests.
     */
    ContentModule.prototype.getOpenBuyingByConsumer = function (accountId, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([accountId, convertAsset], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise((function (resolve, reject) {
            var operation = new database_1.DatabaseOperations.GetOpenBuyingsByConsumer(accountId);
            _this.dbApi.execute(operation)
                .then(function (buyingObjects) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    if (!assets || assets.length === 0) {
                        reject(_this.handleError(ContentError.asset_fetch_failed));
                        return;
                    }
                    var result = convertAsset ? _this.formatPrices(buyingObjects, assets) : buyingObjects;
                    resolve(result);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        }));
    };
    /**
     * Get consumer's bought content identified by URI.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a0b6a59e429592430cd91c6f8c82a5d6c
     *
     * @param {string} accountId                    Consumer's account id in format '1.2.X'. Example '1.2.345'
     * @param {string} URI                          Content URI. Example 'ipfs:QmQ9MBkzt6QcDtBhg7qenDcXtm1s6VVSogtSHa2zbXKsFb'
     * @param {boolean} convertAsset                Optional parameter to convert amounts and fees of BuyingContent from blockchain asset
     *                                              amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                              Default: false.
     * @returns {Promise<BuyingContent[] | null>}   List of bought content with URI.
     */
    ContentModule.prototype.getBuyingByConsumerURI = function (accountId, URI, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([accountId, URI, convertAsset], [types_1.Type.string, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise((function (resolve, reject) {
            var operation = new database_1.DatabaseOperations.GetBuyingByConsumerURI(accountId, URI);
            _this.dbApi.execute(operation)
                .then(function (buyingObjects) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    if (!assets || assets.length === 0) {
                        reject(_this.handleError(ContentError.asset_fetch_failed));
                        return;
                    }
                    var result = convertAsset ? _this.formatPrices(buyingObjects, assets) : buyingObjects;
                    resolve(result);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        }));
    };
    /**
     * Bought content history of account.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a58b3b366a008ae2b0b7acd352da9969e
     *
     * @param {string} accountId            Account id in format '1.2.X'. Example '1.2.345'
     * @param {boolean} convertAsset        Optional parameter to convert amounts and fees of BuyingContent from blockchain asset
     *                                      amount format to right precision format of asset. Example: 100000000 => 1 DCT.
     *                                      Default: false.
     * @returns {Promise<BuyingContent[]>}  List of BuyingContent.
     */
    ContentModule.prototype.getBuyingHistoryObjectsByConsumer = function (accountId, convertAsset) {
        var _this = this;
        if (convertAsset === void 0) { convertAsset = false; }
        if (!validator_1.Validator.validateArguments([accountId, convertAsset], [types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            var getBuyingsHistoryObjectsByConsumerOp = new database_1.DatabaseOperations.GetBuyingsHistoryObjectsByConsumer(accountId);
            _this.dbApi.execute(getBuyingsHistoryObjectsByConsumerOp)
                .then(function (buyingObjects) {
                var listAssetsOp = new database_1.DatabaseOperations.ListAssets('', 100);
                _this.dbApi.execute(listAssetsOp)
                    .then(function (assets) {
                    if (!assets || assets.length === 0) {
                        reject(_this.handleError(ContentError.asset_fetch_failed));
                        return;
                    }
                    var result = convertAsset ? _this.formatPrices(buyingObjects, assets) : buyingObjects;
                    resolve(result);
                })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        });
    };
    /**
     * Format price Asset amounts to asset precision.
     *
     * @param {IContentExchangeObject[]} content     List of content to format.
     * @param {DCoreAssetObject[]} assets           Complete list of assets for formatting.
     * @returns {IContentExchangeObject[]}           List of content with formatted prices.
     */
    ContentModule.prototype.formatPrices = function (content, assets) {
        if (!validator_1.Validator.validateArray(content, content_1.ContentExchangeObject)) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        var result = content.map(function (obj) {
            var objCopy = Object.assign({}, obj);
            var assetsToFormat = [objCopy.price.hasOwnProperty('map_price')
                    ? objCopy.price.map_price[0][1]
                    : objCopy.price];
            if (objCopy.paid_price_before_exchange) {
                assetsToFormat.push(objCopy.paid_price_before_exchange);
            }
            if (objCopy.paid_price_after_exchange) {
                assetsToFormat.push(objCopy.paid_price_after_exchange);
            }
            assetsToFormat.forEach(function (priceAsset) {
                var asset = assets.find(function (a) { return a.id === priceAsset.asset_id; });
                priceAsset.amount = utils_1.Utils.formatAmountForAsset(priceAsset.amount, asset);
            });
            return objCopy;
        });
        return result;
    };
    /**
     * Calculate price of content submit for file size.
     *
     * @param fileSize  Size of file in bytes
     */
    ContentModule.prototype.getFileSize = function (fileSize) {
        return Math.ceil(fileSize / (1024 * 1024));
    };
    /**
     * Calculate submit price of content based on file size, expiration date and selected seeders.
     *
     * @param content SubmitObject for content to be uploaded
     */
    ContentModule.prototype.calculateFee = function (content) {
        var num_days = moment(content.date).diff(moment(), 'days') + 1;
        var fee = Math.ceil(this.getFileSize(content.size) *
            content.seeders.reduce(function (fee, seed) { return fee + seed.price.amount * num_days; }, 0));
        return fee;
    };
    /**
     * Request buy content.
     * https://docs.decent.ch/developer/group___wallet_a_p_i___content.html#ga5c57a25ade4da4c36466bd12f4b65401
     *
     * @param {string} contentId        Id of content to be bought in format '2.13.X'. Example: '2.13.456'
     * @param {string} buyerId          Account id of user buying content in format '1.2.X'. Example: '1.2.345'
     * @param {string} elGammalPub      ElGammal public key which will be used to identify users bought content
     * @param {string} privateKey       Private key to sign broadcasted transaction in WIF(hex) (Wallet Import Format) format.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @return {Promise<boolean>}       Value confirming successful transaction broadcasting.
     */
    ContentModule.prototype.buyContent = function (contentId, buyerId, elGammalPub, privateKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([contentId, buyerId, elGammalPub, privateKey, broadcast], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            _this.getContent(contentId)
                .then(function (content) {
                var buyOperation = new transaction_1.Operations.BuyContentOperation(content.URI, buyerId, content.price.map_price[0][1], 1, { s: elGammalPub });
                var transaction = new transactionBuilder_1.TransactionBuilder();
                transaction.addOperation(buyOperation);
                _this.finalizeAndBroadcast(transaction, privateKey, broadcast)
                    .then(function (res) { return resolve(transaction.operations[0]); })
                    .catch(function (err) { return reject(err); });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.fetch_content_failed, err));
            });
        });
    };
    /**
     * List available seeders ordered by price.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a0fb24b59633fe48d8d4ff0bec4412f7b
     *
     * @param {number} resultSize       Number of results per request. Default 100(Max)
     * @return {Promise<Seeder[]>}      List of available Seeder objects.
     */
    ContentModule.prototype.getSeeders = function (resultSize) {
        var _this = this;
        if (resultSize === void 0) { resultSize = 100; }
        if (!validator_1.Validator.validateArguments([resultSize], [types_1.Type.number])) {
            throw new TypeError('Invalid parameters');
        }
        var dbOperation = new database_1.DatabaseOperations.ListSeeders(resultSize);
        return new Promise(function (resolve, reject) {
            _this.dbApi
                .execute(dbOperation)
                .then(function (result) {
                resolve(result);
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.database_operation_failed, err));
            });
        });
    };
    /**
     * Get list of not expired purchased content for account.
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a9b19baba864926274ef141c879b29e28
     *
     * @param {string} accountId        Account id in format '1.2.X'. Example: '1.2.345'
     * @param {string} order            Order of returned content list. Default is SearchParamsOrder.createdDesc
     * @param {string} startObjectId    Content object id from which list starts in format '2.13.X'. Example '2.13.234'. Default '0.0.0'
     * @param {string} term             Term to search in purchased content. Default ''
     * @param {number} resultSize       Number of results. Default 100(Max)
     * @return {Promise<Content[]>}     List of purchased content.
     */
    ContentModule.prototype.getPurchasedContent = function (accountId, order, startObjectId, term, resultSize) {
        var _this = this;
        if (order === void 0) { order = database_1.SearchParamsOrder.createdDesc; }
        if (startObjectId === void 0) { startObjectId = '0.0.0'; }
        if (term === void 0) { term = ''; }
        if (resultSize === void 0) { resultSize = 100; }
        if (!validator_1.Validator.validateArguments([accountId, order, startObjectId, term, resultSize], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            if (!accountId) {
                reject('missing_parameter');
                return;
            }
            _this.searchContent({ count: resultSize })
                .then(function (allContent) {
                var dbOperation = new database_1.DatabaseOperations.GetBoughtObjectsByCustomer(accountId, order, startObjectId, term, resultSize);
                _this.dbApi
                    .execute(dbOperation)
                    .then(function (boughtContent) {
                    var result = [];
                    boughtContent.forEach(function (bought) {
                        allContent.forEach(function (content) {
                            if (bought.URI === content.URI) {
                                bought.synopsis = JSON.parse(bought.synopsis);
                                content.buy_id = bought.id;
                                result.push(content);
                            }
                        });
                    });
                    resolve(result);
                })
                    .catch(function (err) {
                    reject(_this.handleError(ContentError.database_operation_failed, err));
                });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.fetch_content_failed, err));
            });
        });
    };
    /**
     * List rating for given content id.
     *
     * @param {string} contentId        Content if in format '2.13.X'. Example '2.13.456'
     * @param {string} forUser          Account id to search for user's ratings for conentnt, in format '1.2.X'. Example '1.2.345'.
     * @param {string} ratingStartId    Rating id to start list from.
     * @param {number} count
     * @return {Promise<Array<Rating>>}
     */
    ContentModule.prototype.getRating = function (contentId, forUser, ratingStartId, count) {
        var _this = this;
        if (ratingStartId === void 0) { ratingStartId = ''; }
        if (count === void 0) { count = 100; }
        if (!validator_1.Validator.validateArguments([contentId, forUser, ratingStartId, count], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            _this.getContent(contentId)
                .then(function (res) {
                _this.searchFeedback(forUser, res.URI, ratingStartId, count)
                    .then(function (res) { return resolve(res); })
                    .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
            })
                .catch(function (err) {
                reject(_this.handleError(ContentError.fetch_content_failed, err));
            });
        });
    };
    // TODO: need to discuss with Riso
    /**
     * https://docs.decent.ch/developer/classgraphene_1_1app_1_1database__api__impl.html#a624e679ac58b3edfc7b817e4a46e3746
     */
    ContentModule.prototype.searchFeedback = function (accountId, contentURI, ratingStartId, count) {
        var _this = this;
        if (count === void 0) { count = 100; }
        if (!validator_1.Validator.validateArguments([accountId, contentURI, ratingStartId, count], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.number])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var getAccountOp, accounts, err_1, account, operation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        getAccountOp = new database_1.DatabaseOperations.GetAccounts([accountId]);
                        accounts = [];
                        if (!accountId) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.dbApi.execute(getAccountOp)];
                    case 2:
                        accounts = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        reject(this.handleError(ContentError.api_connection_failed, err_1));
                        return [3 /*break*/, 4];
                    case 4:
                        if (accounts.length !== 0 && !accounts[0]) {
                            reject(this.handleError(ContentError.account_fetch_failed));
                            return [2 /*return*/];
                        }
                        account = accounts[0];
                        operation = new database_1.DatabaseOperations.SearchFeedback(account ? account.name : '', contentURI, ratingStartId, count);
                        this.dbApi.execute(operation)
                            .then(function (res) {
                            resolve(res);
                        })
                            .catch(function (err) {
                            reject(_this.handleError(ContentError.database_operation_failed, err));
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Get author and co-authors of content.
     *
     * @param {string} URI   Content URI. Example 'ipfs:QmQ9MBkzt6QcDtBhg7qenDcXtm1s6VVSogtSHa2zbXKsFb'
     */
    ContentModule.prototype.getAuthorCoAuthors = function (URI) {
        var _this = this;
        if (!validator_1.Validator.validateArguments(arguments, [types_1.Type.string])) {
            throw new TypeError('Invalid parameters');
        }
        return new Promise(function (resolve, reject) {
            var operation = new database_1.DatabaseOperations.GetContent(URI);
            _this.dbApi.execute(operation)
                .then(function (content) {
                if (!content) {
                    resolve(null);
                    return;
                }
                resolve([content.author, content.co_authors.map(function (ca) { return ca[0]; })]);
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.database_operation_failed, err)); });
        });
    };
    /**
     * Send feedback for bought content with comment.
     * https://docs.decent.ch/developer/classgraphene_1_1wallet_1_1detail_1_1wallet__api__impl.html#a34d9dc81d177f87e5f501f182cf9212f
     *
     * @param {string} contentURI       Content URI. Example 'ipfs:QmQ9MBkzt6QcDtBhg7qenDcXtm1s6VVSogtSHa2zbXKsFb'
     * @param {string} consumer         Account id in format '1.2.X'. Example '1.2.345'
     * @param {string} comment          Comment for feedback.
     * @param {number} rating           Rating number from interval 1(Bad)-5(Good).
     * @param {string} consumerPKey     Account's private key to sign transaction in WIF(hex) (Wallet Import Format) format.
     * @param {boolean} broadcast       Transaction is broadcasted if set to 'true'. Default value is 'true'.
     * @returns {Promise<boolean>}      Value confirming successful transaction broadcasting.
     */
    ContentModule.prototype.leaveCommentAndRating = function (contentURI, consumer, comment, rating, consumerPKey, broadcast) {
        var _this = this;
        if (broadcast === void 0) { broadcast = true; }
        if (!validator_1.Validator.validateArguments([contentURI, consumer, comment, rating, consumerPKey, broadcast], [types_1.Type.string, types_1.Type.string, types_1.Type.string, types_1.Type.number, types_1.Type.string, types_1.Type.boolean])) {
            throw new TypeError(ContentError.invalid_arguments);
        }
        return new Promise(function (resolve, reject) {
            var operation = new transaction_1.Operations.LeaveRatingAndComment(contentURI, consumer, comment, rating);
            var transaction = new transactionBuilder_1.TransactionBuilder();
            transaction.addOperation(operation);
            _this.apiConnector.connection()
                .then(function (res) {
                _this.finalizeAndBroadcast(transaction, consumerPKey, broadcast)
                    .then(function (res) { return resolve(transaction.operations[0]); })
                    .catch(function (err) {
                    if (err.stack.indexOf('content != idx.end') >= 0) {
                        reject(_this.handleError(ContentError.content_not_bought, err));
                    }
                    else {
                        reject(_this.handleError(ContentError.transaction_broadcast_failed, err));
                    }
                });
            })
                .catch(function (err) { return reject(_this.handleError(ContentError.api_connection_failed, err)); });
        });
    };
    return ContentModule;
}(ApiModule_1.ApiModule));
exports.ContentModule = ContentModule;
//# sourceMappingURL=content.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/modules/content.js
// module id = 89
// module chunks = 0